import Keycloak from '@/utils/keycloak';
import '@fortawesome/fontawesome-free/css/all.css';
import '@mdi/font/css/materialdesignicons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import HighchartsVue from 'highcharts-vue';
import Vue from 'vue';
import LynusIcon from '@/ui/components/components/LynusIcon.vue';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import { VueEditor } from 'vue2-editor';
import VueKonva from 'vue-konva';
import VueGauge from 'vue-gauge';
import ResizeObserver from 'v-resize-observer';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import i18n from '@/ui/plugins/i18n';
import App from '@/ui/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/ui/plugins/vuetify';
import 'leaflet/dist/leaflet.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import {
  envClientId,
  envFaviconURL,
  envRealm,
  envTitle,
  envProjectOpenSubpage,
  envKeycloakURL,
} from '@/utils/env';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import '@fontsource/clear-sans';
import '@/ui/scss/main.scss';

Vue.config.productionTip = false;

Vue.component('lynus-icon', LynusIcon);

Vue.use(VueKonva);
Vue.use(HighchartsVue);
Vue.use(ResizeObserver);
Vue.component(VueQrcode.name, VueQrcode);
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.component('VueGauge', VueGauge);
Vue.component('VueEditor', VueEditor);

Vue.mixin({
  // make important env variables accessible throughout whole app
  data() {
    return {
      title: envTitle,
      projectOpenSubpage: envProjectOpenSubpage,
    };
  },
  created() {
    // set title and favicon
    document.title = envTitle;
    const favicon = document.getElementById('favicon');
    favicon?.setAttribute('href', envFaviconURL);
  },
});

// @ts-ignore
const keycloak = new Keycloak({
  url: envKeycloakURL,
  realm: envRealm,
  clientId: envClientId,
});

keycloak
  .init({
    onLoad: 'login-required',
    checkLoginIframe: false,
  })
  .then((authenticated: boolean) => {
    if (!authenticated) {
      keycloak.login();
      return;
    }

    // getting everything from the keycloak.tokenParsed attribute (the JWT content)
    store.commit(
      'app/setUser',
      {
        id: keycloak.tokenParsed?.sub,
        email: keycloak.tokenParsed?.email,
        first_name: keycloak.tokenParsed?.given_name,
        last_name: keycloak.tokenParsed?.family_name,
        super_admin:
          keycloak.tokenParsed?.staff === 'true' ||
          keycloak.tokenParsed?.staff === true,
        partner: keycloak.tokenParsed?.partner, // if the user is assigned to a patner, the partner id will be stored else it will be undefined or empty string
      },
      { root: true },
    );

    // Set up token refresh
    // Refresh token 10 seconds before it expires
    const tokenRefreshInterval =
      (keycloak.tokenParsed?.exp ?? 0) - (keycloak.tokenParsed?.iat ?? 0) - 10;
    setInterval(() => {
      keycloak
        .updateToken(tokenRefreshInterval)
        .then((refreshed: boolean) => {
          if (refreshed) {
            console.log('Token refreshed');
          }
        })
        .catch(() => {
          console.error('Failed to refresh token, logging out...');
          keycloak.logout();
        });
    }, tokenRefreshInterval * 1000);

    new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: (h) => h(App),
    }).$mount('#app');
  })
  // @ts-ignore
  .catch((error) => {
    console.error('Keycloak initialization failed:', error);
  });

// Add to Vue prototype to access keycloak from components
Vue.prototype.$keycloak = keycloak;
